import AiAssistantExpandableTree from "../../../../../AiAssistantExpandableTree/AiAssistantExpandableTree";
import ToolCallIndicatorInputBlock from "../../../ToolCallIndicatorInputBlock/ToolCallIndicatorInputBlock";

export interface ToolCallIndicatorNodeOptionalInputBlockProps {
  input?: Record<string, unknown>;
  hasInputParseError?: boolean;
  layout: "pending" | "completed";
  wrapInTreeItem: boolean;
}

export default function ToolCallIndicatorNodeOptionalInputBlock({
  input,
  hasInputParseError,
  layout,
  wrapInTreeItem,
}: ToolCallIndicatorNodeOptionalInputBlockProps) {
  if (!input) return null;

  const block = (
    <ToolCallIndicatorInputBlock
      layout={layout}
      input={input}
      hasInputParseError={hasInputParseError}
      withInputLabel={layout === "completed"}
      className={wrapInTreeItem ? "" : "mt-2 mb-1"}
    />
  );

  return wrapInTreeItem ? (
    <AiAssistantExpandableTree.Item branchYOffset="0.9em">
      {block}
    </AiAssistantExpandableTree.Item>
  ) : (
    block
  );
}
